import { REDIRECT_TO_PARAM, REDIRECT_TO_PAYMENTS } from '../constants/query';

const contextUtils = {
  /** Returns true if the redirect query param is payments. Accepts a full URL, a path with a query, or a search string. */
  isRedirectToPayments(urlOrSearch = '') {
    const search = urlOrSearch.split('#')[0];
    const queryParams = new URLSearchParams(search.slice(search.indexOf('?') + 1));
    return queryParams.get(REDIRECT_TO_PARAM) === REDIRECT_TO_PAYMENTS;
  },
};

export default contextUtils;
